import './PersonnelList.scss'
import React, { useEffect, useRef, useState } from 'react'

import userIcon from './../../assets/icons/user-icon.svg'
import loadingEmployees from './../../assets/icons/loading-employees.png'

import { EmployeeList } from '../../types/Reservation'
import { IEmployeeSummary } from '../../types/Employee'

import { InputText } from 'primereact/inputtext'
import { RadioButton } from 'primereact/radiobutton'
import { ProgressSpinner } from 'primereact/progressspinner'
import { OverlayPanel } from 'primereact/overlaypanel'

import AsyncImage from '../ui/AsyncImage'
import { useTranslation } from 'react-i18next'

const PersonnelList = (props: {
  height: number
  isSelectEmployee: boolean
  data: EmployeeList[]
  onSelectEmployee: (employee: EmployeeList) => void
  selectedFloor: boolean
}) => {
  const { t } = useTranslation()
  const categories = [
    { name: t('most-used-words.all'), key: 'all' },
    { name: t('calendar.my-squad'), key: 'team' },
    { name: t('calendar.my-team'), key: 'peer' },
  ]

  const divStyle = { height: 'calc(100% - ' + (props.height + 10) + 'px)' }
  const opPersonnel = useRef<OverlayPanel>(null)
  const [searchName, setSearchName] = useState('')
  const [loginEmployee, setLoginEmployee] = useState<IEmployeeSummary>()
  const [selectedCategory, setSelectedCategory] = useState(categories[0])
  const [selectEmployeeInfo, setSelectEmployeeInfo] = useState<EmployeeList>()
  const [employeeList, setEmployeeList] = useState<EmployeeList[]>(props.data)
  const [allEmployeeList, setAllEmployeeList] = useState<EmployeeList[]>(props.data)

  useEffect(() => {
    let item = localStorage.getItem('employee')
    if (item !== null) {
      setLoginEmployee(JSON.parse(item) as IEmployeeSummary)
    }
  }, [])
  useEffect(() => {
    let _employeeList = props.data
    if (_employeeList && selectedCategory.key == 'team') {
      setEmployeeList(
        _employeeList.filter(
          (employee) =>
            employee.employee?.isMyTeamReservation == true && employee.employee?.employeeId !== loginEmployee?.id
        )
      )
      setAllEmployeeList(
        _employeeList.filter(
          (employee) =>
            employee.employee?.isMyTeamReservation == true && employee.employee?.employeeId !== loginEmployee?.id
        )
      )
    } else if (_employeeList && selectedCategory.key == 'peer') {
      let _tempemployeeList = _employeeList.filter(
        (employee) =>
          employee.employee?.isMyTeamReservation == false && employee.employee?.employeeId !== loginEmployee?.id
      )
      setEmployeeList(
        _tempemployeeList.filter(
          (employee) =>
            employee.employee?.isPeerOrTeamMemberReservation == true &&
            employee.employee?.employeeId !== loginEmployee?.id
        )
      )
      setAllEmployeeList(
        _tempemployeeList.filter((employee) => employee.employee?.isPeerOrTeamMemberReservation == true)
      )
    } else {
      setEmployeeList(_employeeList)
      setAllEmployeeList(_employeeList)
    }
  }, [props.data, selectedCategory])
  const filter = (e: { target: { value: any } }) => {
    const keyword = e.target.value
    const terms = keyword.split(' ')
    if (keyword !== '') {
      const results = allEmployeeList.filter((employee) => {
        return terms.every((w: any) => employee.employee?.employeeFullName.toLowerCase().includes(w.toLowerCase()))
      })
      setEmployeeList(results)
    } else {
      setEmployeeList(allEmployeeList)
    }
    setSearchName(keyword)
  }
  const selectEmployee = (e: React.MouseEvent<HTMLDivElement>, employee: EmployeeList) => {
    e.stopPropagation()
    opPersonnel.current?.toggle(e, e.target)
    setSelectEmployeeInfo(employee)
  }

  return (
    <div className={'of-personnel-list'} style={divStyle}>
      <div className="d-flex flex-row bd-highlight mb-3">
        {categories.map((category) => {
          if (!loginEmployee?.isManager && category.key == 'team') {
            return
          }
          return (
            <div key={category.key} className="p-2 d-flex align-items-center">
              <RadioButton
                className={'me-1'}
                inputId={category.key}
                name="category"
                value={category}
                onChange={(e) => setSelectedCategory(e.value)}
                checked={selectedCategory.key === category.key}
              />
              <label htmlFor={category.key}>{category.name}</label>
            </div>
          )
        })}
      </div>
      <div className={'of-personnel-title my-3'}>{t('calendar.everybody-in-floor')}</div>
      <span className="p-input-icon-left w-100" style={{ position: 'relative' }}>
        <i className="pi ">
          <img src={userIcon} alt="" />
        </i>
        <InputText
          className={'w-100 of-name-search'}
          value={searchName}
          onChange={filter}
          placeholder={t('input-texts.search-someone')}
        />
        {searchName !== '' && (
          <i
            className="pi pi-times"
            style={{ cursor: 'pointer', position: 'absolute', right: '1rem', color: '#6c757d' }}
            onClick={() => {
              setSearchName('')
              setEmployeeList(allEmployeeList)
            }}
          />
        )}
      </span>

      <div className={'of-personnels my-3'}>
        {props.selectedFloor ? (
          employeeList ? (
            employeeList.length > 0 ? (
              employeeList.map((employee) => (
                <div
                  key={employee.employee?.employeeId}
                  onClick={(e) => {
                    props.isSelectEmployee ? selectEmployee(e, employee) : props.onSelectEmployee(employee)
                  }}
                  className="of-personnel d-flex flex-row mb-3">
                  <div className="p-2 d-flex align-items-center">
                    <AsyncImage className={'of-photo'} src={employee.employee?.employeePhoto} alt="" />
                  </div>
                  <div className="p-2">
                    <div className={'of-name'}>{employee.employee?.employeeFullName}</div>
                    <div className={'of-title'}>{employee.employee?.employeePositionName}</div>
                    <div
                      onClick={(e) => {
                        selectEmployee(e, employee)
                      }}
                      className={'of-date'}>
                      {employee.reservationList?.length +
                        ' ' +
                        t('date-terms.daily') +
                        ' ' +
                        t('most-used-words.reservation')}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: '#495057' }}>{t('overlaypanel-texts.nobody-with-reservation')}</p>
            )
          ) : (
            <div className={'h-100'}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center',
                  height: '100%',
                }}>
                <ProgressSpinner style={{ width: '120px' }} />
                <img style={{ position: 'absolute', width: '40px' }} src={loadingEmployees} />
              </div>
            </div>
          )
        ) : (
          <div>{t('overlaypanel-texts.look-at-location')}</div>
        )}
      </div>
      <OverlayPanel ref={opPersonnel} id="overlay_panel" style={{ width: '250px' }} className="personnel-overlaypanel">
        <div className="d-flex justify-content-between">
          <div className={'title'}>
            {'"' + selectEmployeeInfo?.reservationList?.length + `" ${t('overlaypanel-texts.daily-reservation')}`}
          </div>
          <div>
            <i className="arrow pi pi-times of-times-btn" onClick={(e) => opPersonnel?.current?.hide()} />
          </div>
        </div>

        <div className={'row sub-title'}>
          <div className={'col-6'}>{t('input-texts.date')}</div>
          <div className={'col-6'}>{t('calendar.table-no')}</div>
        </div>
        <div className={'personnel-list'}>
          {selectEmployeeInfo?.reservationList?.map((reservation) => (
            <div className={'row mb-1'}>
              <div className={'col-6'}>{reservation.reservationDateStr}</div>
              <div className={'col-6'}>{reservation.tableNum}</div>
            </div>
          ))}
        </div>
      </OverlayPanel>
    </div>
  )
}

export default PersonnelList
